(() => {
  // SAFE STATIC POPUP (no API)
  const names = ["Aadhira", "Aakanksha", "Aanya", "Aarti", "Aarushi", "Aasmi", "Abha", "Aditi", "Advika", "Ahaana", "Ahilya", "Akshara", "Aleena", "Amala", "Amaya", "Amisha", "Amrita", "Amritha", "Amulya", "Anaisha", "Anamika", "Ananya", "Anavi", "Anika", "Anitha", "Anjali", "Anju", "Ankita", "Annapurna", "Anshika", "Antara", "Aparna", "Archana", "Arpita", "Aruna", "Arya", "Asha", "Ashika", "Ashita", "Ashwini", "Asmita", "Aswathi", "Avani", "Avantika", "Ayushi", "Bhuvana", "Bhavya", "Charitha", "Charu", "Chaitra", "Chandana", "Chandni", "Deepa", "Deepali", "Deepti", "Devanshi", "Devika", "Dhanashree", "Disha", "Divya", "Diya", "Durga", "Eesha", "Ekta", "Eshani", "Esha", "Gauri", "Gayathri", "Geetika", "Gitanjali", "Gopika", "Grishma", "Gulika", "Hamsika", "Harini", "Haritha", "Hema", "Himani", "Indira", "Ishita", "Isha", "Ishaani", "Jaanvi", "Jagruti", "Jaya", "Jayashree", "Jhanvi", "Juhi", "Jyoti", "Jyothika", "Kalyani", "Kamakshi", "Kamini", "Kanchana", "Kanika", "Karthika", "Kavita", "Kavya", "Keerthana", "Kiranmayi", "Kripa", "Krisha", "Kritika", "Kumud", "Kusum", "Lahari", "Latha", "Lavanya", "Lekha", "Likhita", "Lipsa", "Lipika", "Madhu", "Madhulika", "Madhuri", "Mahima", "Maithili", "Malathi", "Malavika", "Malini", "Manasi", "Manisha", "Manjari", "Meenakshi", "Meera", "Meghana", "Mehak", "Mitali", "Mouna", "Mridula", "Mitali", "Mrunmayi", "Myra", "Namrata", "Nandini", "Navya", "Neelima", "Neha", "Niharika", "Nikita", "Nilima", "Nisha", "Nishitha", "Nithya", "Oviya", "Pallavi", "Parineeta", "Parvathi", "Pooja", "Poorva", "Prachi", "Pranita", "Pranjali", "Prarthana", "Preethi", "Priya", "Priyanka", "Purnima", "Radha", "Rachita", "Ragini", "Rajashree", "Raksha", "Ramya", "Ranjana", "Rashi", "Rati", "Reema", "Renuka", "Reshma", "Revathi", "Rhea", "Riddhi", "Rishika", "Ritika", "Riya", "Rohini", "Roma", "Roopa", "Rukmini", "Rupa", "Saanvi", "Sadhana", "Sakshi", "Saloni", "Samiksha", "Samriddhi", "Sandhya", "Sangita", "Sanjana", "Sankalpa", "Sanya", "Saraswati", "Sarika", "Saritha", "Seetha", "Shalini", "Sharanya", "Sharvya", "Shilpa", "Shreya", "Shraddha", "Shruti", "Simran", "Sindhu", "Siya", "Smriti", "Sneha", "Sona", "Sonali", "Soumya", "Sowmya", "Sreeja", "Sreelakshmi", "Srishti", "Sruthi", "Subha", "Suhani", "Sujata", "Sukanya", "Sumedha", "Sunaina", "Supriya", "Swathi", "Swara", "Tanisha", "Tanvi", "Tejaswini", "Trisha", "Uma", "Urmila", "Usha", "Vaibhavi", "Vaidehi", "Vaishnavi", "Varalakshmi", "Varsha", "Vasudha",
     "Veda", "Vedika", "Veena", "Vibha", "Vidya", "Vidhatri", "Vinaya", "Vindhya", "Vinuja", "Vishakha", "Vrinda", "Yamini"];
  const cities = ["Delhi",
"Mumbai",
"Bengaluru",
"Hyderabad",
"Chennai",
"Kolkata",
"Pune",
"Ahmedabad",
"Jaipur",
"Surat",
"Lucknow",
"Indore",
"Chandigarh",
"Nagpur",
"Coimbatore",
"Visakhapatnam",
"Vadodara",
"Kochi",
"Patna",
"Bhopal",
"Kanpur",
"Thiruvananthapuram",
"Nashik",
"Ludhiana",
"Madurai",
"Raipur",
"Ranchi",
"Guwahati",
"Dehradun",
"Amritsar",
"Vijayawada",
"Trichy",
"Mysuru",
"Jodhpur",
"Varanasi",
"Rajkot",
"Udaipur",
"Aurangabad",
"Meerut",
"Jalandhar",
"Hubballi",
"Bhavnagar",
"Jammu",
"Thrissur",
"Mangalore",
"Gwalior",
"Salem",
"Bilaspur",
"Haridwar",
"Ajmer",
"Allahabad (Prayagraj)"];
  const products = [
                  { name: "The Aveline Set", image: "https://cdn.shopify.com/s/files/1/0632/6698/0037/files/4B10FA81-7C40-4211-80A2-7A3156538D37.png?v=1786343941" },

              { name: "Cherry Red Double-Breasted Power Suit", image: "https://cdn.shopify.com/s/files/1/0632/6698/0037/files/F7088447-EEF0-4B12-894D-B623C9078DDA.png?v=1765636466" },

        { name: "Monaco Red Power Suit ", image: "https://cdn.shopify.com/s/files/1/0632/6698/0037/files/IMG-0079.png?v=1785987857" },

    { name: "Noir Signature Co-ord Set ", image: "https://cdn.shopify.com/s/files/1/0632/6698/0037/files/Gemini_Generated_Image_617wf6617wf6617w.png?v=1763542210" },
        
    { name: "Monaco Noir Power Suit", image: "https://cdn.shopify.com/s/files/1/0632/6698/0037/files/IMG-9857_5d9c5f7f-2ba3-446b-9ff9-a2fa470c7022.png?v=1785567388" },

    { name: "Ivory Bloom Power Set 💗", image: "https://cdn.shopify.com/s/files/1/0632/6698/0037/files/IMG_6386.png?v=1772858856" },
    { name: "The Duchess Bloom Co-ord Set", image: "https://cdn.shopify.com/s/files/1/0632/6698/0037/files/C6B976E0-5794-40BF-A857-9A93203D3D53.png?v=1784952679" },
    { name: "Mocha Pearl Power Co-ord Set", image: "https://cdn.shopify.com/s/files/1/0632/6698/0037/files/FCDFC169-5A31-44A7-8838-B74AEF35FF05.png?v=1783088641" },

     { name: "Noir Royale Co-ord Set", image: "https://cdn.shopify.com/s/files/1/0632/6698/0037/files/70C637B5-3586-4519-95FA-C8B3A7EEE860.png?v=1783068946" },
    { name: "Sandstone Power Co-ord Set ", image: "https://cdn.shopify.com/s/files/1/0632/6698/0037/files/IMG-8809.png?v=1749724395" },
    { name: "Ivory Royale Co-ord Set", image: "https://cdn.shopify.com/s/files/1/0632/6698/0037/files/E4F2F94A-5182-4B7A-8920-52BF5ABBC525.png?v=1783068758" },
    { name: "Buttercream Belle Co-ord Set", image: "https://cdn.shopify.com/s/files/1/0632/6698/0037/files/2B8783A8-C048-41D8-9225-278B20833B1D.png?v=1783068488" },
    
     { name: "Ruby Royale Co-ord Set", image: "https://cdn.shopify.com/s/files/1/0632/6698/0037/files/IMG-1969.png?v=1783067992" },
    { name: "Rosé Noir Co-ord Set", image: "https://cdn.shopify.com/s/files/1/0632/6698/0037/files/IMG-0552.png?v=1779361821" },
    { name: "Ivory Rose Power Suit Co-ord Set", image: "https://cdn.shopify.com/s/files/1/0632/6698/0037/files/558E6C70-FE27-46D3-A165-56D8AE25799B.png?v=1780135535" },
    { name: "Pink Tides Handpainted Blazer Set", image: "https://cdn.shopify.com/s/files/1/0632/6698/0037/files/IMG-8944.png?v=1778814480" },

    { name: "Valentina Co-ord Set", image: "https://cdn.shopify.com/s/files/1/0632/6698/0037/files/IMG_9140.png?v=1782907437" },
    { name: "Pearl Co-ord Set ", image: "https://cdn.shopify.com/s/files/1/0632/6698/0037/files/6893DF9B-B770-4FB5-86E7-FE716140BAFA.png?v=1775380446" },
    
  ];

  const random = arr => arr[Math.floor(Math.random() * arr.length)];
  const randomMinutes = () => `${Math.floor(Math.random() * 8) + 1} mins ago`;

  function showPopup() {
    const popup = document.getElementById("purchase-popup");
    const text = document.getElementById("purchase-text");
    const img = document.getElementById("purchase-image");
    if (!popup || !text || !img) return;

    const p = random(products);
    const name = random(names);
    const city = random(cities);

    text.textContent = `${name} from ${city} bought the ${p.name} ${randomMinutes()}`;
    img.src = p.image;

    popup.classList.add("show");
    popup.style.display = "flex";

    setTimeout(() => popup.classList.remove("show"), 9000);
  }

  window.addEventListener("load", () => {
    setTimeout(showPopup, 6000);
    setInterval(showPopup, 35000);
  });
})();
